<template>
  <div class="p-2 bg-gray-200 dark:bg-gray-900" @mousedown.stop="userFilter()">
    <addModal @refresh="getAll()" ref="addModal" />
    <equipmentSelectorModal
      :initialSelectedCategories="equipmentCategories"
      @equipment-selected="handleEquipmentSelected"
    />
    <combinedOrder
      :bulkId="bulkId"
      @vehicle="(r) => showVehicleList(r)"
      @reportModal="(r) => showDetailModal(r)"
    />
    <editModal @refresh="getAll()" :rowId="selected.id" />
    <!-- <noteDetail :note="note" /> -->
    <notesModal
      :orderId="selected.id"
      :orderStatus="selected.state"
      :isBulk="1"
    />
    <vehicleModalVue
      @refresh="handleVehicleRefresh"
      @before-close="handleModalClose"
      :rowId="selected.id"
      :isDisabled="selected.tonnage <= selected.receivedTonnageForJob"
      :orderNo="selected.orderNo"
      :orderItem="selected"
      :isArchived="isArchived"
      @changeOrderReceivedTonnage="changeOrderReceivedTonnage"
    />
    <reportModal
      :rowId="selected.id"
      :order-no="selected.orderNo"
      :active="1"
      :moduleId="12"
    />
    <reportModalVue :detail="selected" />
    <div class="w-full">
      <div class="h-full p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm">
        <div class="w-full">
          <LyrausTable
            :data="List"
            :columns="columns"
            :innerTable="innerTableColumns"
            :enablePagination="true"
            :isLoading="load"
            :stickyLeft="['orderNo']"
            :stickyRight="['buttonsColumn']"
            :batchOperations="!isArchived"
            :searchBar="true"
            :searchProp="search"
            @update-search-value="(val) => handleSearchValue(val)"
            :handleSearch="handleSearch"
            :alternateRowBg="['white', 'gray-100']"
            :rightExtraSlot="!isArchived"
            :dblClickableColumns="dblClickableColumns"
            :buttonsColumn="{ label: 'İşlem' }"
            :pageCount="pageCount"
            :pageProp="currentPage"
            @update-current-page="handleCurrentPage"
            :totalCount="totalCount"
            @dbl-row-click="handleRowClick"
            :paginationButtonColor="'red-600'"
            :paginationHoverColor="'red-700'"
            :containerClass="'p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm'"
            :innerThClass="'py-2 text-left text-xxs font-medium bg-red-300 tracking-wider border-gray-200'"
            :innerTdClass="'whitespace-nowrap text-xxs bg-red-200 py-2'"
          >
            <template v-slot:searchBar> <SearchInput :value="search" :isFull="true" @searcing="(val) => {handleSearchValue(val); handleSearch();}" /> </template>
            <template v-slot:colButtons="{ item }">
              <div class="flex items-center justify-end space-x-2 mr-1">
                <button
                  :class="
                    item.isCombineOrder !== 1 ? 'cursor-default opacity-20' : ''
                  "
                  @click="
                    item.isCombineOrder === 1 ? combinedOrderModal(item) : null
                  "
                >
                  <img
                    class="w-4 h-4"
                    src="../../../assets/ship/diagram.png"
                    alt=""
                  />
                </button>
              </div>
              <div class="flex items-center justify-end space-x-2 mx-1">
                <button @click="noteDetailModal(item)">
                  <i class="far fa-sticky-note"></i>
                </button>
              </div>
              <div class="flex items-center justify-end space-x-2 mx-1">
                <button
                  :disabled="isArchived"
                  :class="isArchived ? 'opacity-30 cursor-not-allowed' : {
                    'opacity-30':
                      item.state == 'Tamamlandı' ||
                      item.state == 'Başlamadı' ||
                      item.state == 'Kontrol Ediliyor' ||
                      item.state == 'Son Yükte',
                  }"
                  @click="
                    !isArchived &&
                    item.state !== 'Tamamlandı' &&
                      item.state !== 'Kontrol Ediliyor' &&
                      item.state !== 'Başlamadı' &&
                      item.state !== 'Son Yükte' &&
                      completePlanning(item)
                  "
                >
                  <i class="fas fa-check text-gray-700"></i>
                </button>
              </div>
              <div class="flex items-center justify-end space-x-2 mx-1">
                <button @click="showDetailModal(item)">
                  <i class="fas fa-search text-gray-700"></i>
                </button>
              </div>
              <div class="flex items-center justify-end space-x-2 mx-1">
                <button :disabled="isArchived" :class="isArchived && 'opacity-30 cursor-not-allowed'" @click="!isArchived && deleteItem(item)">
                  <i class="fas fa-trash text-gray-700"></i>
                </button>
              </div>
            </template>
            <template v-slot:batchOperations>
              <asyncBtn
                v-if="!isArchived"
                icon="fas fa-plus "
                :text="$t('operations.planning.newBtnTitle')"
                class="w-36 btn"
                @click="() => $modal.show('add-plan-modal')"
              />
            </template>
            <template v-slot:rowButtons="{ item, columnKey }">
              <button
                v-if="columnKey === 'state' && [5, 6, 7].includes(item.stateId) && !isOrderCompleted(item)"
                @click="showActionPanel(item)"
                class="cursor-pointer"
              >
                <img
                  class="w-5 h-5 ml-3 animate-pulse duration-200 select-none"
                  src="../../../../src/assets/error-icons/warning.png"
                  alt=""
                />
              </button>
              <div v-if="columnKey === 'reservation'" class="flex items-center justify-center">
                <div v-if="item.reservedVehicleCount > 0" class="group relative">
                  <div class="flex items-center space-x-1 px-2 py-1 rounded-full bg-orange-100 dark:bg-orange-900 border border-orange-300 dark:border-orange-700">
                    <i class="far fa-clock text-orange-600 dark:text-orange-400 text-xs"></i>
                    <span class="text-xs font-semibold text-orange-700 dark:text-orange-300">{{ item.reservedVehicleCount }}</span>
                  </div>
                  <div class="absolute bottom-full left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs rounded py-1 px-2 mb-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50 pointer-events-none">
                    {{ item.reservedVehicleCount }} araç rezerve ({{ item.sentVehicleCount }} gönderildi)
                    <div v-if="item.earliestScheduledTime" class="text-xxs mt-1">
                      En erken: {{ formatDateTime(item.earliestScheduledTime) }}
                    </div>
                  </div>
                </div>
                <div v-else-if="item.sentVehicleCount > 0" class="flex items-center space-x-1 px-2 py-1 rounded-full bg-green-100 dark:bg-green-900 border border-green-300 dark:border-green-700">
                  <i class="fas fa-check text-green-600 dark:text-green-400 text-xs"></i>
                  <span class="text-xs font-semibold text-green-700 dark:text-green-300">{{ item.sentVehicleCount }}</span>
                </div>
                <span v-else class="text-xs text-gray-400">-</span>
              </div>
              <button
                v-if="columnKey === 'vehicleCount'"
                @click="showVehicleList(item)"
              >
                <div
                  class="flex items-center justify-center border rounded-lg w-8 h-6 group relative"
                  :class="
                    item.isLiveAssignment
                      ? 'animate-pulse border-blue-400 bg-blue-400 text-white'
                      : item.rejectStatus > 0 && !isOrderCompleted(item)
                      ? 'animate-pulse border-red-400 bg-red-400 text-gray-100'
                      : 'border-gray-400'
                  "
                >
                  <i v-if="item.isLiveAssignment" class="fas fa-bolt text-xs mr-0.5"></i>
                  {{ item.vehicleCount }}

                  <!-- Tooltip for live assignment mode -->
                  <div
                    v-if="item.isLiveAssignment"
                    class="absolute bottom-full left-1/2 transform -translate-x-1/2 bg-blue-800 text-white text-xs rounded py-1 px-2 mb-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50 pointer-events-none">
                    Canlı Atama Modu Aktif ({{ item.recomendedVehicleCount }} araç öneriliyor)
                  </div>
                </div>
              </button>
            </template>
            <template v-slot:rightExtra>
              <div v-if="!isArchived" class="flex justify-between items-center">
                <userFilterModal
                  ref="modalActive"
                  :selectedItems="selectedItems"
                  :load="load"
                  @selected-items-changed="handleSelectedItemsChanged"
                />
              </div>
            </template>
            <template v-slot:sortButton="{ columnKey }">
              <div
                v-if="columnKey === searchColumn"
                @click="clearSearch()"
                class="cursor-pointer mr-1"
              >
                <i class="fas fa-times text-red-600"></i>
              </div>
              <button
                v-if="columnKey === 'orderNo'"
                class="pr-1"
                @click="toggleSort(columnKey)"
              >
                <i v-if="sortColumn !== 'orderNo'" class="fas fa-sort"></i>
                <i
                  v-if="sortState === 1 && sortColumn === 'orderNo'"
                  class="fas fa-sort-alpha-up"
                ></i>
                <i
                  v-if="sortState === 2 && sortColumn === 'orderNo'"
                  class="fas fa-sort-alpha-down"
                ></i>
              </button>
              <button
                v-if="columnKey === 'customer'"
                class="pr-1"
                @click="toggleSort(columnKey)"
              >
                <i v-if="sortColumn !== 'customer'" class="fas fa-sort"></i>
                <i
                  v-if="sortState === 1 && sortColumn === 'customer'"
                  class="fas fa-sort-alpha-up"
                ></i>
                <i
                  v-if="sortState === 2 && sortColumn === 'customer'"
                  class="fas fa-sort-alpha-down"
                ></i>
              </button>
              <button
                v-if="columnKey === 'receivedName'"
                class="pr-1"
                @click="toggleSort(columnKey)"
              >
                <i v-if="sortColumn !== 'receivedName'" class="fas fa-sort"></i>
                <i
                  v-if="sortState === 1 && sortColumn === 'receivedName'"
                  class="fas fa-sort-alpha-up"
                ></i>
                <i
                  v-if="sortState === 2 && sortColumn === 'receivedName'"
                  class="fas fa-sort-alpha-down"
                ></i>
              </button>
              <button
                v-if="columnKey === 'deliveredName'"
                class="pr-1"
                @click="toggleSort(columnKey)"
              >
                <i
                  v-if="sortColumn !== 'deliveredName'"
                  class="fas fa-sort"
                ></i>
                <i
                  v-if="sortState === 1 && sortColumn === 'deliveredName'"
                  class="fas fa-sort-alpha-up"
                ></i>
                <i
                  v-if="sortState === 2 && sortColumn === 'deliveredName'"
                  class="fas fa-sort-alpha-down"
                ></i>
              </button>
              <button
                v-if="columnKey === 'productType'"
                class="pr-1"
                @click="toggleSort(columnKey)"
              >
                <i v-if="sortColumn !== 'productType'" class="fas fa-sort"></i>
                <i
                  v-if="sortState === 1 && sortColumn === 'productType'"
                  class="fas fa-sort-alpha-up"
                ></i>
                <i
                  v-if="sortState === 2 && sortColumn === 'productType'"
                  class="fas fa-sort-alpha-down"
                ></i>
              </button>
              <button
                v-if="columnKey === 'estimatedComplateDate'"
                class="pr-1"
                @click="toggleSort(columnKey)"
              >
                <i
                  v-if="sortColumn !== 'estimatedComplateDate'"
                  class="fas fa-sort"
                ></i>
                <i
                  v-if="
                    sortState === 1 && sortColumn === 'estimatedComplateDate'
                  "
                  class="fas fa-sort-alpha-up"
                ></i>
                <i
                  v-if="
                    sortState === 2 && sortColumn === 'estimatedComplateDate'
                  "
                  class="fas fa-sort-alpha-down"
                ></i>
              </button>
            </template>
            <template v-slot:filterButton="{ columnKey }">
              <statusPanel
                v-if="columnKey === 'state' && !isArchived"
                @stopFiltering="() => stopFiltering()"
                :statusList="bulkStatus"
                :isBulk="true"
                :initialStatus="filterType"
                @setStatusFilter="
                  (val) => ((filterType = val), (actionStateId = val))
                "
              />
            </template>
          </LyrausTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Global Components
// import PaginationComponents from "@/components/general/pagination.vue";
// import searchInput from "@/components/general/search-input.vue";
// import tableLoader from "@/components/general/table-loader.vue";
// import tableResizeBtn from "@/components/general/table.resize.btn.vue";
import SearchInput from "@/components/general/search-input.vue";
import notesModal from "@/components/modals/notesModal/index.vue";
import noteDetail from "@/components/modals/noteDetail/index.vue";
import asyncBtn from "@/components/general/asyncBtn.vue";
import userFilterModal from "@/components/filters/userFiltering/index.vue";
import statusPanel from "@/components/filters/filterTableStatus/index.vue";
import reportModalVue from "./components/action-report-modal.vue";
import reportModal from "@/components/modals/report.modal/index.vue";
import {usePlanAction} from "./composables/planActions";
import {convertTonnage} from './tools/convertTonnage.js';
import { getAllPlanning } from "./tools/collectivePlanningService";
import {alerts} from './composables/alerts';
// Local Components
import addModal from "./components/add/index.vue";
import editModal from "./components/edit/index.vue";
import vehicleModalVue from "./components/vehicle-list/index.vue";
import combinedOrder from "./components/combinedOrder/index.vue";
import equipmentSelectorModal from "./components/equipment-selector.modal.vue";

// networking
import axios from "axios";
import { bulkPlanning } from "@/networking/urlmanager";

//npm
import moment from "moment";
import { LyrausTable } from "lyraus-ui";

export default {
  name: "collectivePlanning-module",
  props: {
    isArchived: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    // PaginationComponents,
    // tableLoader,
    // tableResizeBtn,
    // searchInput,
    notesModal,
    addModal,
    editModal,
    vehicleModalVue,
    reportModalVue,
    asyncBtn,
    userFilterModal,
    statusPanel,
    reportModal,
    combinedOrder,
    noteDetail,
    equipmentSelectorModal,
    SearchInput 
  },
  data() {
    return {
      // isFullScreen: false,
      selectedItems: [],
      List: [],
      note: "",
      columns: [
        {
          key: "orderNo",
          label: "#",
        },
        {
          key: "customer",
          label: "Müşteri",
          maxLength: 16,
        },
        {
          key: "receivedName",
          label: "Dolum",
          maxLength: 16,
        },
        {
          key: "deliveredName",
          label: "Teslim",
          maxLength: 16,
        },
        {
          key: "productType",
          label: "Ürün",
        },
        {
          key: "status",
          label: "Toplam / Kalan",
        },
        {
          key: "vehicleCount",
          label: "Araçlar",
          dontDisplay: true,
          center: true,
        },
        {
          key: "estimatedComplateDate",
          label: "Teslim Süresi",
          isDate: true,
        },
        // {
        //   key: "reservation",
        //   label: "Rezervasyon",
        //   width: 120,
        // },
        {
          key: "state",
          label: "Durum",
          width: 160,
        },
      ],
      innerTableColumns: [
        { key: "orderName", label: "Kaynak" },
        { key: "fillingAdress", label: "Dolum Adresi" },
        { key: "deliveryAdress", label: "Teslim Adresi" },
        { key: "invoicedCompany", label: "Fatura Adresi" },
        { key: "estimatedComplateDate", label: "Tahmini Teslim Tarihi" },
      ],
      dblClickableColumns: [
        "customer",
        "receivedName",
        "deliveredName",
        "productType",
      ],
      load: false,
      search: "",
      sortState: 0,
      sortColumn: "",
      searchColumn: "",
      filterArr: [],
      totalCount: 0,
      pageCount: 1,
      currentPage: 0,
      selected: [],
      filterType: null,
      clickSearch: false,
      bulkStatus: [
        { id: 2, name: "Devam Ediyor" },
        { id: null, name: "Hepsi" },
        { id: 1, name: "Başlamadı" },
        { id: 3, name: "Durduruldu" },
        { id: 4, name: "Teslim Tarihi Geçti" },
        { id: 5, name: "Kriz Var" },
        { id: 6, name: "Araç Sayısı Fazla" },
        { id: 7, name: "Araç Sayısı Az" },
        { id: 8, name: "Son Yükte" },
        { id: 9, name: "Tamamlandı" },
      ],
      needInterval: true, // app.vue da setInterval için lazım silme
      bulkId: "",
      actionStateId: 0,
      isFromCrisisMode: false, // Canlı Atama'dan kriz durumu yönlendirmesi ile geldi mi
      planAction: null,
      equipmentCategories: [], // Ekipman kategorileri için
    };
  },
  created() {
    if (this.isArchived) {
      this.getAll();
    } else {
      const tabIndex = this.$store.state.pages.List.findIndex(
        (i) => i.id === this.$route.name
      );
      if (tabIndex === -1) {
        this.getAll();
      }

      this.$store.commit("addTab", {
        id: this.$route.name,
        title: "Toplu Planlama",
        url: this.$route.path,
      });
    }

    // Canlı Atama modülünden gelen olayları dinle
    this.$root.$on('showVehicleAddModal', this.handleVehicleAddRequest);

    // Equipment modal event'lerini dinle
    this.$root.$on('updateEquipmentCategories', (categories) => {
      this.equipmentCategories = categories;
    });
  },
  methods: {
    handleEquipmentSelected(categories) {
      this.equipmentCategories = categories;
      // Add modal'a seçilen kategorileri bildir
      this.$root.$emit('equipment-selected-from-parent', categories);
    },
    formatDateTime(datetime) {
      if (!datetime) return '-';
      return moment(datetime).format('DD.MM.YYYY HH:mm');
    },
    stopFiltering(){
      this.filterType=null
      this.actionStateId=null;
      this.getAll();
    },
    changeOrderReceivedTonnage(val){
      if(val.isAllStopped==1){
        this.selected.receivedTonnageForJob =  this.selected.receivedTonnageForJob - (val.vehicleLength*28)
      }else if(val.isAllStopped==2){
        this.selected.receivedTonnageForJob =  this.selected.receivedTonnageForJob + (val.vehicleLength*28)
      }
    },
    noteDetailModal(item) {
      this.selected = item;
      this.$modal.show("notes-modal");
    },
    handleCurrentPage(val) {
      this.currentPage = val;
    },
    handleSearchValue(val) {
      this.search = val;
    },
    handleSearch() {
      this.clickSearch = false;
      this.searchColumn = "";
      this.filterType = 5;
      this.currentPage = 0;
      this.getAll();
    },
    clearSearch() {
      this.search = "";
      this.handleSearch();
    },
    userFilter() {
      if (this.isArchived) return;
      this.$refs.modalActive.show();
    },
    combinedOrderModal(item) {
      this.bulkId = item.id;
      this.$modal.show("combined-order-modal");
    },
    showDetailModal(item) {
      this.selected = item;
      this.$modal.show("report-modal");
    },
    async showVehicleList(item) {
      this.selected = item;

      // Kriz kontrolü yap
      if (item.rejectStatus > 0) {

        // recomendedCount yoksa vehicleCount kullan veya hesapla
        if (!item.recomendedCount && item.tonnage) {
          // Basit hesaplama: tonnaj / 26 (ortalama araç kapasitesi)
          const tonnage = item.unitType === "TON" ? parseFloat(item.tonnage) : item.tonnage * 26;
          item.recomendedCount = Math.ceil(tonnage / 26);
        }

        // Gerçek aktif araç sayısını hesapla (reddedilenleri çıkar)
        const vehicleCount = Number(item.vehicleCount) || 0;
        const sentCount = Number(item.sentVehicleCount) || 0;
        const reservedCount = Number(item.reservedVehicleCount) || 0;
        const rejectCount = Number(item.rejectStatus) || 0;

        // Öncelik sırası:
        // 1. Eğer sentVehicleCount veya reservedVehicleCount varsa onları kullan
        // 2. Yoksa vehicleCount kullan ama reddedilenleri çıkar
        let assignedVehicleCount;
        if (sentCount > 0 || reservedCount > 0) {
          // Rezervasyon sistemi kullanılıyor
          assignedVehicleCount = sentCount + reservedCount;
        } else {
          // Normal sistem, vehicleCount'tan reddedilenleri çıkar
          assignedVehicleCount = Math.max(0, vehicleCount - rejectCount);
        }

        
        // Kriz kontrolü: Sadece kırmızı yanıp sönen durumda ve canlı atama aktif değilse kriz var
        const requiredVehicles = item.recomendedCount || 0;
        const isCompleted = item.state === 'Tamamlandı' || item.stateId === 9 || item.state === 'Son Yükte' || item.stateId === 8;
        const hasRejectStatus = item.rejectStatus > 0;
        const isLiveAssignment = item.isLiveAssignment;
        const isCrisis = !isCompleted && !isLiveAssignment && hasRejectStatus && assignedVehicleCount < requiredVehicles;

        if (isCrisis) {
          // Kriz uyarısı göster
          const neededVehicles = requiredVehicles;
          const assignedVehicles = vehicleCount;
          const deficit = Math.max(0, requiredVehicles - assignedVehicles);

          const message = `"${item.orderNo}" numaralı sipariş için kriz durumu tespit edildi!\n\n` +
                         `İhtiyaç duyulan araç sayısı: ${neededVehicles}\n` +
                         `Mevcut atanmış araç sayısı: ${assignedVehicles}\n` +
                         `Eksik araç sayısı: ${deficit}\n\n` +
                         `Araç ekleme ekranı açılacak.`;

          const result = await this.$swal.fire({
            icon: 'warning',
            title: 'Kriz Durumu Uyarısı!',
            html: message.replace(/\n/g, '<br>'),
            showCancelButton: true,
            confirmButtonText: 'Tamam, Araç Ekle',
            cancelButtonText: 'İptal',
            confirmButtonColor: '#ef4444',
            cancelButtonColor: '#9ca3af',
          });

          if (!result.isConfirmed) {
            // Kullanıcı iptal etti, modal açma
            return;
          }
        }
      }

      this.$modal.show("vehicle-list-modal");
    },

    async handleVehicleRefresh() {

      // Retry mekanizması: Backend'den güncel veri gelene kadar maksimum 3 kez dene
      let retryCount = 0;
      const maxRetries = 3;
      let updatedOrder = null;

      while (retryCount < maxRetries) {
        // Her denemede biraz bekle (ilk 500ms, sonra 800ms, sonra 1200ms)
        const waitTime = 500 + (retryCount * 400);
        await new Promise(resolve => setTimeout(resolve, waitTime));

        // Verileri yenile
        await this.getAll(false);

        // Seçili sipariş güncellenmiş veride bul
        updatedOrder = this.List.find(order => order.id === this.selected.id);

        if (updatedOrder) {
          const vehicleCount = Number(updatedOrder.vehicleCount) || 0;
          const sentCount = Number(updatedOrder.sentVehicleCount) || 0;
          const reservedCount = Number(updatedOrder.reservedVehicleCount) || 0;
          const rejectCount = Number(updatedOrder.rejectStatus) || 0;

          // Öncelik sırası (showVehicleList ile aynı mantık):
          // 1. Eğer sentVehicleCount veya reservedVehicleCount varsa onları kullan
          // 2. Yoksa vehicleCount kullan ama reddedilenleri çıkar
          let assignedVehicleCount;
          if (sentCount > 0 || reservedCount > 0) {
            assignedVehicleCount = sentCount + reservedCount;
          } else {
            assignedVehicleCount = Math.max(0, vehicleCount - rejectCount);
          }

          const requiredVehicles = updatedOrder.recomendedCount || 0;

          
          // Eğer araç sayısı güncellenmiş ise (0'dan farklı) veya yeterli ise, döngüyü kır
          if (assignedVehicleCount > 0 || updatedOrder.rejectStatus === 0) {
            break;
          }
        }

        retryCount++;

       
      }

      if (updatedOrder) {
        // Son kontrol: Yeterli araç var mı?
        const vehicleCount = Number(updatedOrder.vehicleCount) || 0;
        const sentCount = Number(updatedOrder.sentVehicleCount) || 0;
        const reservedCount = Number(updatedOrder.reservedVehicleCount) || 0;
        const rejectCount = Number(updatedOrder.rejectStatus) || 0;

        // Öncelik sırası (showVehicleList ile aynı mantık):
        let assignedVehicleCount;
        if (sentCount > 0 || reservedCount > 0) {
          assignedVehicleCount = sentCount + reservedCount;
        } else {
          assignedVehicleCount = Math.max(0, vehicleCount - rejectCount);
        }

        const requiredVehicles = updatedOrder.recomendedCount || 0;

        // Eğer yeterli araç atandıysa ve hala rejectStatus varsa, Vue reaktif olarak sıfırla
        if (assignedVehicleCount >= requiredVehicles && updatedOrder.rejectStatus > 0) {
          // Liste içindeki objeyi bul ve güncelle
          const index = this.List.findIndex(order => order.id === this.selected.id);
          if (index !== -1) {
            this.$set(this.List[index], 'rejectStatus', 0);
          } 
        } 

        // Seçili sipariş güncellendi, selected'ı güncelle
        this.selected = updatedOrder;
      }
    },

    async handleModalClose() {

      // Modal kapanırken 1 saniye bekle ve son bir kontrol yap
      await new Promise(resolve => setTimeout(resolve, 1000));
      await this.getAll(false);

      const updatedOrder = this.List.find(order => order.id === this.selected.id);
      if (updatedOrder) {
        const vehicleCount = Number(updatedOrder.vehicleCount) || 0;
        const sentCount = Number(updatedOrder.sentVehicleCount) || 0;
        const reservedCount = Number(updatedOrder.reservedVehicleCount) || 0;
        const rejectCount = Number(updatedOrder.rejectStatus) || 0;

        // Öncelik sırası (showVehicleList ile aynı mantık):
        let assignedVehicleCount;
        if (sentCount > 0 || reservedCount > 0) {
          assignedVehicleCount = sentCount + reservedCount;
        } else {
          assignedVehicleCount = Math.max(0, vehicleCount - rejectCount);
        }

        const requiredVehicles = updatedOrder.recomendedCount || 0;

       
        // Yeterli araç varsa rejectStatus'ü sıfırla
        if (assignedVehicleCount >= requiredVehicles && updatedOrder.rejectStatus > 0) {
          const index = this.List.findIndex(order => order.id === this.selected.id);
          if (index !== -1) {
            this.$set(this.List[index], 'rejectStatus', 0);
          }
        }
      }
    },

    handleRowClick(data, key) {
      this.clickSearch = true;
      this.search = "";
      this.filterType = 5;
      this.currentPage = 0;
      this.searchColumn = key;
      this.search = data[key];
      this.getAll(true);
    },
    toggleSort(column) {
      this.currentPage = 0;
      if (this.sortColumn !== column) {
        this.sortState = 0;
      }
      this.sortColumn = column;
      // Toggle the sort state between 0, 1, and 2
      this.sortState = (this.sortState + 1) % 3;

      // Determine the filter based on the sort state
      let filter = [];
      if (this.sortState === 1) {
        filter = [{ sort: 1, column }];
      } else if (this.sortState === 2) {
        filter = [{ sort: 2, column }];
      } else {
        this.sortColumn = "";
      }

      this.filterArr = [JSON.stringify(filter)];
      this.getAll();
    },
    async getAll(load = true) {
      if (load) {
        this.List = [];
        this.load = load;
      }

      const params = {
        page: this.currentPage,
        search: this.search,
        userList: this.selectedItems,
      };
      if (this.isArchived) {
        params.isArchived = true;
      }

      if (this.sortState) {
        params.filter = this.filterArr;
      }

      if (this.searchColumn) {
        params.column = this.searchColumn;
      }

      if (this.actionStateId) {
        if (this.actionStateId === 2) {
          params.excludeCompleted = true;
        } else {
          params.actionStateId = this.actionStateId;
        }
      }
      try {
          const res = await getAllPlanning(this.$store.state.userData.token,params);
          this.List = res.detail.map((item) => {
            // Spot planning stateId'si 1 veya 3 ise öncelikle "-" göster, diğer durumlarda actionState veya stateName kullan
            const hasActionState = item?.actionState !== null;
            const isSpotPlanningState = [1, 3].includes(item?.stateId);

            return {
              ...item,
              state: isSpotPlanningState ? "-" : (hasActionState ? item.actionState[0].title : item.stateName || "-"),
              stateId: isSpotPlanningState ? "-" : (hasActionState ? item.actionState[0].actionStateId : item.stateId),
              status: convertTonnage(item),
              action: hasActionState ? item.actionState[0] : null,
              outpointLat:item?.fillingLatitude,
              outpointLng:item?.fillingLongitude,
              // Null değerleri boş string'e çevir (LyrausTable truncateText hatası için)
              customer: item?.customer || "",
              receivedName: item?.receivedName || "",
              deliveredName: item?.deliveredName || "",
              productType: item?.productType || "",
            };
          });
          this.totalCount = res.totalCount;
          this.pageCount = res.pageCount;

          this.load = false;
      } catch(err){
            console.log("err", err);
            this.errorBox(err.response);
            this.load = false;
      }
    },
    isOrderCompleted(item) {
      // Sipariş tamamlandı mı kontrolü (Son Yükte dahil)
      return item.state === 'Tamamlandı' || item.stateId === 9 || item.state === 'Son Yükte' || item.stateId === 8;
    },
    deleteItem(item) {
      const {deleteItem} = usePlanAction({
        swalBox: this.swalBox,
        t: (key) => this.$i18n.t(key),
        errorBox: this.errorBox,
        token: this.$store.state.userData.token,
      })
      deleteItem({rowId: item.id.toString() , orderNo: item.orderNo} , this.getAll);
    },
    completePlanning(item) {
      const {completePlan} = usePlanAction({
        swalBox: this.swalBox,
        t: (key) => this.$i18n.t(key),
        errorBox: this.errorBox,
        token: this.$store.state.userData.token,
      })
      completePlan({rowId: item.id,tonnage: item.tonnage - item.receivedTonnage,orderNo: item.orderNo} , this.getAll);
    },
    showActionPanel(item) {
      if ([5, 6, 7].includes(item.stateId)) {
        this.selected = item;
        this.$modal.show("action-reports-modal");
      }
    },
    handleSelectedItemsChanged(newSelectedItems) {
      this.selectedItems = newSelectedItems;
    },
    
    // Canlı Atama modülünden gelen araç ekleme isteğini işle
    handleVehicleAddRequest({ orderId, orderNo }) {
      // Önce siparişi bul
      this.getAll(true); // Verileri güncelle
      
      // Bu işlem tamamlandıktan sonra bir timeout ile devam ediyoruz
      setTimeout(() => {
        // Siparişi ID'ye göre bul
        const order = this.List.find(o => o.id === orderId);
        
        if (order) {
          // Siparişi seç ve araç ekleme penceresini aç
          this.selected = order;
          this.$modal.show("vehicle-list-modal");
          
          // Kriz durumu bayrağını ayarla (Canlı Atama'dan geldiği için)
          this.isFromCrisisMode = true;
          alerts.showCrisisAlert({swalBox:this.swalBox, orderNo});
        } else {
          console.warn(`${orderId} ID'li sipariş bulunamadı.`);
          alerts.showOrderNotFoundAlert({swalBox: this.swalBox});
        }
      }, 1000); // 1 saniye bekle - getAll işleminin tamamlanması için yeterli süre
    },
  },
  beforeDestroy() {
    // Event listener'ları temizle
    this.$root.$off('showVehicleAddModal', this.handleVehicleAddRequest);
  },
  filters: {
    getDateFormat(val) {
      return moment(val).format("LLL");
    },
  },
  watch: {
    currentPage() {
      if (this.currentPage > -1) {
        this.getAll();
      }
    },
    selectedItems() {
      this.getAll();
    },
    actionStateId() {
      this.getAll();
    },
  },
};
</script>
